import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

const ConIcon: React.FC<IconProps> = (props) => (

<svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" {...props} xmlns="http://www.w3.org/2000/svg">
<path d="M14.7031 1.56641H4.20312C3.37812 1.56641 2.70312 2.24141 2.70312 3.06641V13.5664C2.70312 14.3914 3.37812 15.0664 4.20312 15.0664H7.20312L9.45312 17.3164L11.7031 15.0664H14.7031C15.5281 15.0664 16.2031 14.3914 16.2031 13.5664V3.06641C16.2031 2.24141 15.5281 1.56641 14.7031 1.56641ZM10.8631 9.72641L9.45312 12.8164L8.04313 9.72641L4.95312 8.31641L8.04313 6.90641L9.45312 3.81641L10.8631 6.90641L13.9531 8.31641L10.8631 9.72641Z" fill="currentColor"/>
</svg>




);

export default ConIcon;
